import { Pipe, PipeTransform } from "@angular/core";
import { Contact } from "@models";

@Pipe({
	name: "contactSearch",
	standalone: false
})
export class ContactSearchPipe implements PipeTransform {
	public transform(value: Contact[], search: string): Contact[] {
		if (!search) {
			return value;
		}
		return (value || []).filter((c) => {
			const toSearch = [c.getName()].concat(c.getFields().map((f) => f.getValue()));
			return toSearch.some((s) =>
				new RegExp(search.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&"), "gi").test(s)
			);
		});
	}
}
